module.exports = __webpack_public_path__ + "static/media/marker.f5cbcda4.svg";